import React, { createContext, useContext } from 'react'
/**
 * Read-only chrome flags, derived by Layout from the route's ChromeConfig
 * rule. Pages don't toggle these — declare chrome in ChromeConfig instead.
 */
type LayoutProviderContextArgs = {
	showWallet: boolean
	showFooter: boolean
	fixedHeader: boolean
	embed: boolean
}

const LayoutProviderContext = createContext<LayoutProviderContextArgs | null>(null)

export const LayoutProvider: React.FC<LayoutProviderContextArgs> = ({ children, ...props }) => {
	return <LayoutProviderContext.Provider value={props}>{children}</LayoutProviderContext.Provider>
}

export const useLayoutProvider = () => {
	const context = useContext(LayoutProviderContext)
	if (!context) {
		throw new Error('No LayoutProvider found !!!')
	}
	return { ...context }
}
